import { apiClient } from './apiClient';

const base = '/api/integrations';

export const integrationsService = {
  list: () => apiClient.get(base),
  update: (type, config) => apiClient.put(`${base}/${type}`, config),
  mcp: {
    list: () => apiClient.get('/api/mcp'),
    add: serverData => apiClient.post('/api/mcp', serverData),
    update: (id, serverData) =>
      apiClient.post(`/api/mcp/${id}/update`, serverData),
    remove: id => apiClient.post(`/api/mcp/${id}/delete`, {}),
  },
  zapier: {
    webhooks: {
      list: () => apiClient.get('/api/zapier/webhooks'),
      add: webhookData => apiClient.post('/api/zapier/webhooks', webhookData),
      update: (webhookId, webhookData) =>
        apiClient.put(`/api/zapier/webhooks/${webhookId}`, webhookData),
      remove: webhookId => apiClient.del(`/api/zapier/webhooks/${webhookId}`),
    },
  },
  voip: {
    list: () => apiClient.get(`${base}/voip`),
    update: (provider, config) => apiClient.put(`${base}/voip/${provider}`, config),
    test: provider => apiClient.post(`${base}/voip/${provider}/test`, {}),
  },
  crm: {
    getCatalog: () => apiClient.get('/api/integrations/crm-catalog'),
    install: templateId => apiClient.post('/api/integrations/crm/install', { templateId }),
    save: payload => apiClient.post('/api/integrations/crm/save', payload),
  },
};

export default integrationsService;
